import { createContext } from 'react';

/*
 *  Ported code from react-aria-components as of V.1.2.1 use the original commit in the repo
 *  to diff any added code since the original commit.
 */
var DialogContext = /*#__PURE__*/createContext(null);
var OverlayTriggerStateContext = /*#__PURE__*/createContext(null);

export { DialogContext, OverlayTriggerStateContext };
//# sourceMappingURL=context.esm.js.map
